<script setup>
import { computed } from 'vue'

const props = defineProps({
    data: {
        type: Object,
        default: () => ({}),
    },
})

const emit = defineEmits(['close'])

const headline = computed(() => props.data.headline || 'Message')

const message = computed(() => props.data.message || '')

// The close button is the only control, so it is the acknowledgement: 'primary', which the
// overlay and escape (handled by modal-manager) do not report.
function close() {
    emit('close', 'primary')
}
</script>

<template>
    <div class="simple-message-modal">
        <button
            class="close-button"
            aria-label="Close modal"
            @click="close"
        >
            <BaseIcon
                class="close-icon"
                name="close"
            />
        </button>

        <div class="content">
            <h5 class="headline">
                {{ headline }}
            </h5>
            <p class="message">
                {{ message }}
            </p>
        </div>
    </div>
</template>

<style scoped lang="scss">
@use '@design' as *;

.simple-message-modal {
    position: relative;
    width: 90vw;
    max-width: 500px;
    padding: $s-h $s-h $s-xxxl;
    border: none;
    border-radius: $radius-12;

    @include elevationDialog;

    @include mobileOnly {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: calc(100vw - $s-xxl);
        max-width: none;
        height: auto;
        padding: $s-xxl 30px 36px;
        margin: $s-l;
        border-radius: $radius-16;
    }
}

.close-button {
    position: absolute;
    top: $s-l;
    right: $s-l;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    padding: $s-xxs;
    color: $c-modal-close;
    cursor: pointer;
    background: transparent;
    border: none;
    border-radius: 50%;

    @include transition((color, background-color), fast);

    .close-icon {
        width: $s-l;
        height: $s-l;
    }

    &:hover {
        color: $c-modal-close-hover;
        background: $c-modal-close-hover-bg;
    }

    @include mobileOnly {
        top: $s-l;
        right: $s-l;
    }
}

.content {
    display: flex;
    flex-direction: column;
    gap: 0;
    align-items: flex-start;
    text-align: left;
}

.headline {
    @extend %h5;

    margin: 0;
    margin-bottom: $s-m;
    color: $c-white;

    @include mobileOnly {
        margin-bottom: $s-s;
    }
}

.message {
    @extend %p;

    margin: 0;
    font-size: 16px;
    line-height: 1.5;
    color: $c-text-secondary;

    @include mobileOnly {
        font-size: 14px;
    }
}
</style>
